import React from 'react'

const component = 'jobs'

export function ListItem({ job }) {
    const possibleLanguageUrlSegments = ['de', 'fr', 'ja-jp']
    const pathParts = window.location.pathname.split('/')
    let languageUrlSegment = ''
    if (possibleLanguageUrlSegments.includes(pathParts[1])) {
        languageUrlSegment = '/' + pathParts[1]
    }

    return (
        <li className={`${component}__list-item ${job.id}`}>
            <a
                className={`${component}__list-item-container`}
                href={languageUrlSegment + job.detailUrl}
                title={job.name}
            >
                <div className={`${component}__list-item-content`}>
                    <div className={`${component}__list-item-content-division`}>
                        <span>{job.function.label}</span>
                    </div>
                    <div className={`${component}__list-item-content-city`}>
                        <span>{`${job.location.city}, ${job.COUNTRY.label}`}</span>
                    </div>
                    <div className={`${component}__list-item-content-info-title`}>
                        <span>{job.name}</span>
                    </div>
                    <div className={`${component}__list-item-content-more`}>
                        <span>
                            Find out more<span className="jobs__show-details-icon">➔</span>
                        </span>
                    </div>
                </div>
            </a>
        </li>
    )
}
